module.exports = __webpack_public_path__ + "media/images/official/removeanxieties_graph2-6f5fcb4653d1447589facdf56f0848dd.png";